var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-mt-8 lg:scroll-mt-16"},[_c('div',{staticClass:"relative overflow-hidden transition-all",style:(_vm.styleRoot),attrs:{"aria-expanded":_vm.open,"role":"region"}},[_c('div',{ref:"content",staticClass:"w-full transition-all",style:(_vm.styleChild)},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }